/**
 * Creates a debounced function that delays invoking func until after wait milliseconds
 * @param fn - The function to debounce
 * @param delay - The number of milliseconds to delay
 */
export function debounce<T extends(...args: any[]) => any>(
  fn: T,
  delay: number,
) {
  let timer: ReturnType<typeof setTimeout> | null = null;

  function debounced(this: any, ...args: Parameters<T>): void {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  }

  debounced.cancel = function(): void {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  return debounced as T & { cancel: () => void };
}

// For backward compatibility
export default debounce;
